import { useEffect, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import Container from '../../../../components/Container'
import { useLoading } from '../../../../hooks/loading'
import api from '../../../../services/api'
import { FormPermissionsAssociated } from '../components/Form'
import { apiList } from '../domain/api'
import { nameActions, namePageTitle } from '../domain/info'
import { breadcrumbUpdate } from '../domain/breadcrumb'
import { toolsUpdate } from '../domain/tools'
import { useToast } from '../../../../hooks/toast'

type PermissionData = {
  name: string
  id: number
}

const PermissionsAssociatedUpdate = (): JSX.Element => {
  const { addToast } = useToast()
  const location = useLocation()
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const { activeLoading, disableLoading } = useLoading()
  const [permissionAssociatedItem, setPermissionAssociatedItem] = useState<{
    id: number
    permission_id: number
    routes: number[]
    routesAssociated: PermissionData[]
  }>()

  useEffect(() => {
    async function loadData() {
      activeLoading()
      try {
        const response = await api.get(apiList(id))
        const { data } = response
        setPermissionAssociatedItem(data)
        disableLoading()
      } catch (err) {
        const [, baseUrl, path] = location.pathname.split('/')
        disableLoading()
        addToast({
          type: 'error',
          title: 'Error ao carregar o Grupo de usuário',
          description:
            'Houve um error ao carregar o grupo, tente novamente mais tarde!'
        })
        if (path.includes('update')) {
          history.push(`/${baseUrl}`)
        } else {
          history.push(`/${baseUrl}/${path}`)
        }
      }
    }

    loadData()
  }, [activeLoading, addToast, disableLoading, history, id, location.pathname])
  return (
    <Container
      pageTitle={namePageTitle}
      breadcrumb={breadcrumbUpdate}
      tools={[toolsUpdate]}
    >
      <div className="form-body">
        <FormPermissionsAssociated
          initialValues={{
            idUpdate: Number(permissionAssociatedItem?.id),
            ...permissionAssociatedItem
          }}
          typeForm="update"
        />
      </div>
    </Container>
  )
}

export default PermissionsAssociatedUpdate
